import { useQuery } from '@tanstack/react-query';
import { mockDelay } from '@/shared/api/mockDelay';
import { reportDefinitions, notificationRules, notificationLogs } from './mockData';

/** GET /api/reports/definitions */
export function useReportDefinitions() {
  return useQuery({
    queryKey: ['reports', 'definitions'],
    queryFn: () => mockDelay(reportDefinitions),
  });
}

/** GET /api/reports/notification-rules */
export function useNotificationRules() {
  return useQuery({
    queryKey: ['reports', 'notificationRules'],
    queryFn: () => mockDelay(notificationRules),
  });
}

/** GET /api/reports/notification-logs */
export function useNotificationLogs() {
  return useQuery({
    queryKey: ['reports', 'notificationLogs'],
    queryFn: () => mockDelay(notificationLogs),
  });
}
